export const getRoundedNumber = (num) => (
    Math.round(num * 100) / 100
);

export const parsedCurrency = (value) => {
    return parseFloat((value?.toString() || '').replace(',', '.'))
}

export const formatCurrency = (value = 0) => {
    const numValue = typeof value === 'number' ? value : parseFloat(value) || 0;
    return '$' + numValue.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}